module.exports = __webpack_public_path__ + "static/media/ExternalLink.43445a61.svg";